// The cache status coming from Cloudflare

import type { CacheStatus } from '../types'

// https://developers.cloudflare.com/cache/concepts/cache-responses/
type CloudflareCacheStatus =
  | 'hit'
  | 'miss'
  | 'expired'
  | 'stale'
  // "NONE/UNKNOWN" in the docs
  | 'null'
  | 'bypass'
  | 'revalidated'
  | 'updated'
  | 'dynamic'

/**
 * Gets the cache status from the Cloudflare meta tag in the document.
 *
 * Looks for a meta tag with name="cachestatus" and reads its content attribute.
 * The content represents the Cloudflare cache status for the current page.
 *
 * @returns {CacheStatus} - Returns "hit" or "miss" for those specific statuses,
 *                          "other" for any valid Cloudflare status that isn't hit/miss,
 *                          or "unknown" if the meta tag is missing or has no content
 */
export function getCacheStatus(): CacheStatus {
  const allowedStatuses = ['hit', 'miss']
  const cloudflareCacheStatus: CloudflareCacheStatus | undefined | null =
    document
      .querySelector('meta[name="cachestatus"]')
      ?.getAttribute('content') as CloudflareCacheStatus | null
  if (
    typeof cloudflareCacheStatus === 'string' &&
    cloudflareCacheStatus.trim() !== ''
  ) {
    if (allowedStatuses.includes(cloudflareCacheStatus)) {
      return cloudflareCacheStatus as CacheStatus
    }

    return 'other'
  }

  return 'unknown'
}
